



























































import { defineComponent, reactive, ref } from '@vue/composition-api'
import Controller from './pages/Controller.vue'
import Background from './components/Background.vue'
import { mdiTwitter, mdiTwitch, mdiHome, mdiInformationOutline } from '@mdi/js'

export default defineComponent({
  name: 'App',
  components: { Controller, Background },
  setup() {
    const appName = ref('Remosync Aurora')
    const dialog = ref(false)
    const dialogContents = ref([
      {
        text: 'Focus On! 公式Twitter',
        icon: mdiTwitter,
        link: 'https://twitter.com/focus_on_dj',
      },
      {
        text: 'Focus On! Twitchチャンネル',
        icon: mdiTwitch,
        link: 'https://www.twitch.tv/focuson_dj',
      },
      {
        text: 'heavysick ZERO',
        icon: mdiHome,
        link: 'http://www.heavysick.co.jp/zero/',
      },
    ])
    return {
      appName,
      dialog,
      dialogContents,
      icons: {
        mdiInformationOutline,
      },
    }
  },
})
